import styled, { css } from 'styled-components'
import text from 'styles/text'
import spacing from 'styles/spacing'
import sizing from 'styles/sizing'
import decorations from 'styles/decorations'
import positioning from 'styles/positioning'
import type { TextStyledProps, TextStyledComponent } from 'types/text'

/**
 * Styled text component that combines multiple style functions:
 * typography, spacing, sizing, decorations, and positioning.
 */
export const Text: TextStyledComponent = styled.div(
  ({ ...props }: TextStyledProps) => css`
    ${text(props)}
    ${spacing(props)}
    ${sizing(props)}
    ${decorations(props)}
    ${positioning(props)}
  `,
)
